<template>
    <div class="movie-swiper component">
      <swiper
        class="swiper"
        :options="swiperOption"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
        ref="movieSwiper">
        <swiper-slide v-for="(movie, idx) in movies" :key="idx"><img :src="getProxyImageUrl(movie.image)" /></swiper-slide>
      </swiper>
    </div>
  </template>
  
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  name: 'MovieSwiper',
  props: {
    movies: { type: Array },
    activeIndex: { type: Number, default: 0 }
  },
  components: {
    Swiper,
    SwiperSlide
  },
  data () {
    return {
      swiperOption: {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 4,
        slideToClickedSlide: true,
        spaceBetween: 20,
        updateOnWindowResize: true,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        coverflowEffect: {
          rotate: 0,
          stretch: -1,
          depth: 100,
          modifier: 2,
          slideShadows: false
        },
        pagination: {
          el: '.swiper-pagination'
        }
      }
    }
  },
  watch: {
    movies () {
      // 片單更新（例如換日期）後，等新的 slide 渲染完再把 swiper 移到選取的位置
      this.$nextTick(() => this.syncActiveSlide(true))
    },
    activeIndex () {
      this.syncActiveSlide(false)
    }
  },
  methods: {
    onSwiper (swiper) {

    },
    syncActiveSlide (needUpdate) {
      const swiper = this.swiper && this.swiper.$swiper
      if (!swiper || swiper.destroyed) {
        return
      }
      if (needUpdate) {
        // slide 數量可能改變，先讓 swiper 重新計算
        swiper.update()
      }
      const target = this.activeIndex >= 0 && this.activeIndex < this.movies.length ? this.activeIndex : 0
      if (swiper.activeIndex !== target) {
        swiper.slideTo(target, 0)
      }
    },
    onSlideChange () {
      if (this.swiper) {
        this.$emit('slideChange', this.swiper.$swiper.activeIndex)
      }
    },
    getProxyImageUrl (url) {
      if (!url) {
        return ''
      }

      if (url.startsWith('https://')) {
        return url
      }

      if (url.startsWith('http://')) {
        const proxyUrl = `https://images.weserv.nl/?url=${encodeURIComponent(url.replace('http://', ''))}`
        return proxyUrl
      }

      return url
    }
  },
  mounted () {
    const movieSwiper = this.$refs.movieSwiper
    this.swiper = movieSwiper
    // 掛載前片單就已經載入的情況，watch 不會觸發，這裡補一次同步
    this.syncActiveSlide(true)
  }
}
</script>
  
  <style lang="scss" scoped>
    .movie-swiper {
      width: 100%;
      padding-top: 12.5px;
      padding-bottom: 12.5px;
  
      .swiper {
        width: 100%;
        .swiper-slide {
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          font-weight: bold;
          font-size: 12px;
          background-color: transparent;
          background-position: center;
          background-size: cover;
  
          img {
            width: 100%;
          }
        }
      }
    }
  </style>
